var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 7 7",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 0l.99 2.51L7 3.5l-2.51.99L3.5 7l-.99-2.51L0 3.5l2.51-.99L3.5 0z",
    fill: "#14D1C2"
  })));
}
export default __webpack_public_path__ + "fonts/star-7b76bf3623d3aa61f4649140d5bf1851.svg";
export { SvgStar as ReactComponent };